module.exports = __webpack_public_path__ + "img/ApacheFavicon.7717a33a.png";